import { Injectable } from "@angular/core";

import { ProductCategory } from "../../core/models/product.model";

import { CATEGORY_CONFIG, CATEGORY_ORDER, CategoryKey } from "./category-config";

@Injectable({ providedIn: 'root' })
export class CategoryHelperService {

  private uuidToKeyMap: Record<string, CategoryKey> = {};

  constructor() {
    for (const key of Object.keys(CATEGORY_CONFIG) as CategoryKey[]) {
      CATEGORY_CONFIG[key].forEach(uuid => {
        this.uuidToKeyMap[uuid] = key;
      });
    }
  }

  filterAndSortCategories(
    categories: ProductCategory[],
    channelCategoriesUuid?: string[]
  ): ProductCategory[] {

    let filtered = categories;

    if (channelCategoriesUuid?.length) {
      return categories.filter(cat =>
        channelCategoriesUuid.includes(cat.uuid)
      );
    }

    filtered = categories.filter(cat =>
      this.uuidToKeyMap[cat.uuid] &&
      cat.hasProducts === true
    );

    return filtered.sort((a, b) => {
      const keyA = this.uuidToKeyMap[a.uuid];
      const keyB = this.uuidToKeyMap[b.uuid];

      return CATEGORY_ORDER.indexOf(keyA) - CATEGORY_ORDER.indexOf(keyB);
    });
  }

  mapUuidToKey(uuid?: string): CategoryKey {
    return this.uuidToKeyMap[uuid ?? ''] ?? 'business';
  }
}